import { styled } from "@linaria/react";
import { color } from "@ui";
import Button from "@ui/Button";

export default styled(Button)`
  border-top-left-radius: 0;
  border-top-right-radius: 0;
  border-top: 1px solid ${color.titanium100};
  width: 100%;
  padding: 8px;
  margin-top: auto;
  &:hover {
    background-color: ${color.titanium100};
  }
  &.disabled,
  :disabled {
    opacity: 0.2;
    cursor: not-allowed;
  }
`;
